<template>
    <div class="content">
        <global-tag>
            <span slot="title">地址管理</span>
            <div class="search" slot="search">
                <el-form label-width="120px" :model="queryInfo">
                    <div class="searchBox">
                        <div class="content">
                            <el-row>
                                <el-col :span="4">
                                    <el-form-item label="姓名：">
                                        <el-input
                                            clearable
                                            v-model.trim="queryInfo.orderNum"
                                            style="width: 100%"
                                            placeholder="请输入姓名"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4">
                                    <el-form-item label="性别：">
                                        <el-select
                                            style="width: 100%"
                                            v-model="queryInfo.status"
                                            placeholder="服务类型"
                                        >
                                            <el-option
                                                label="男"
                                                value="0"
                                            ></el-option>
                                            <el-option
                                                label="女"
                                                value="1"
                                            ></el-option>
                                            <el-option
                                                label="已结束"
                                                value="2"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4">
                                    <el-form-item label="联系方式：">
                                        <el-input
                                            clearable
                                            v-model.trim="queryInfo.orderNum"
                                            style="width: 100%"
                                            placeholder="请输入机构养老点名称"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4">
                                    <el-form-item label="用户类型：">
                                        <el-select
                                            style="width: 100%"
                                            v-model="queryInfo.status"
                                            placeholder="服务类型"
                                        >
                                            <el-option
                                                label="男"
                                                value="0"
                                            ></el-option>
                                            <el-option
                                                label="女"
                                                value="1"
                                            ></el-option>
                                            <el-option
                                                label="已结束"
                                                value="2"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4">
                                    <el-form-item label="所属类别：">
                                        <el-select
                                            style="width: 100%"
                                            v-model="queryInfo.status"
                                            placeholder="服务类型"
                                        >
                                            <el-option
                                                label="男"
                                                value="0"
                                            ></el-option>
                                            <el-option
                                                label="女"
                                                value="1"
                                            ></el-option>
                                            <el-option
                                                label="已结束"
                                                value="2"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="btn">
                            <el-button type="primary" @click="querySearch"
                                >查询</el-button
                            >
                        </div>
                    </div>
                </el-form>
            </div>
        </global-tag>
        <div class="table_title">
            <div class="btn_group">
                <el-button
                    type="success"
                    class="button"
                    size="mini"
                    @click="handleTableForm('新增', 'add')"
                    >新增</el-button
                >
                <el-button
                    type="primary"
                    class="button"
                    size="mini"
                    @click="createExcel"
                    >导出</el-button
                >
                <div style="display: none">
                    <input @change="fileChange" id="speechUpload" type="file" />
                </div>
                <label for="speechUpload" class="labelImportBtn">
                    <span>导入</span>
                </label>
                <!-- <el-button-group>
                    <el-button
                        type="success"
                        icon="iconfont icon-xinzeng"
                        @click="handleTableForm('新增', 'add')"
                        >新增</el-button
                    >
                </el-button-group> -->
            </div>
            <!-- 筛选按钮 -->
            <div class="screen_container">
                <el-button-group>
                    <el-button
                        type="primary"
                        icon="el-icon-refresh"
                        @click="clearData"
                    ></el-button>
                    <el-button type="primary" style="padding: 10px 20px">
                        <el-dropdown trigger="click" :hide-on-click="false">
                            <span class="el-dropdown-link">
                                <i
                                    class="el-icon-s-grid el-icon--right"
                                    style="color: #fff"
                                ></i>
                                <i
                                    class="el-icon-arrow-down el-icon--right"
                                ></i>
                            </span>
                            <el-dropdown-menu
                                slot="dropdown"
                                class="table_checkbox"
                            >
                                <el-dropdown-item>
                                    <el-checkbox-group
                                        v-model="tableChekbox"
                                        @change="tableChekboxChange"
                                    >
                                        <el-checkbox label="序号"></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="地址名称"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="地址类型"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="社区负责人"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="联系方式"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox label="状态"></el-checkbox
                                        ><br />
                                        <el-checkbox label="操作"></el-checkbox
                                        ><br />
                                    </el-checkbox-group>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </el-button>
                </el-button-group>
            </div>
        </div>
        <!-- tableb表格 -->
        <div class="table_container">
            <el-table
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                height="550px"
                :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
                border
            >
                <el-table-column
                    type="index"
                    width="70"
                    label="序号"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '序号'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="地址名称"
                    align="center"
                    prop="name"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '地址名称'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="地址类型"
                    align="center"
                    prop="personIdCard"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '地址类型'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="社区负责人"
                    align="center"
                    prop="phone"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '社区负责人'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="联系方式"
                    align="center"
                    prop="phone"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '联系方式'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="状态"
                    align="center"
                    prop="phone"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '状态'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>

                <el-table-column
                    label="操作"
                    align="center"
                    width="200px"
                    fixed="right"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '操作'
                        ) != -1
                    "
                >
                    <template slot-scope="scope">
                        <span
                            @click="handleTableForm('查看', scope.row)"
                            style="margin-right: 12px; cursor: pointer"
                            >查看</span
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination_container">
            <el-pagination
                :page-size="pageOne.pageSize"
                :current-page.sync="pageOne.pageNo"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageOne.total"
                @size-change="handletableDataSize"
                @current-change="handleTableDataChange"
            ></el-pagination>
        </div>
        <add-address
            v-if="addressSate"
            :openData="addressInfo"
            @cancleAddress="cancleAddress"
        ></add-address>
    </div>
</template>
<script>
import addAddress from "./components/addAddress.vue"

import globalTag from "../../components/globalTag"
export default {
    inject: ["reload"], //注入
    components: { addAddress, globalTag },
    data() {
        return {
            addressSate: false,
            addressInfo: {},
            queryInfo: {},
            showAddStatus: false,
            personIdCard: "",
            isSearchContent: false,
            pageOne: { pageSize: 10, pageNo: 1, total: 0 },
            tableData: [],
            dialogVisible: false, //人员编辑
            dialogInfo: {},
            personState: false, //新增人员
            personInfo: {},
            radioId: "",
            tempTableChekbox: [
                "序号",
                "地址名称",
                "地址类型",
                "社区负责人",
                "联系方式",
                "状态",
                "操作",
            ],
            tableChekbox: [
                "序号",
                "地址名称",
                "地址类型",
                "社区负责人",
                "联系方式",
                "状态",
                "操作",
            ],
        }
    },
    created() {
        this.getList()
    },
    methods: {
        cancleAddress(data) {
            if (data == true) {
                this.getList()
            }
        },
        // 搜索
        querySearch() {
            this.getList()
        },
        // 关闭人员信息弹窗
        cancleOpen() {
            this.dialogInfo = {}
            this.dialogVisible = false
            // this.tableData = [];
            this.getList()
        },
        //删除表格信息
        deleteItem(date) {
            let params = {
                communityWorkerId: date.id,
            }
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.$http
                    .request({
                        url: "/admin/communityWorker/info/deleteBySocialOrg",
                        method: "POST",
                        data: params,
                    })
                    .then((res) => {
                        if (res.code === 200) {
                            this.$message.success("删除成功")
                            // this.tableData = [];
                            this.getList()
                        }
                    })
            })
        },
        // 当前页
        handleTableDataChange(val) {
            this.pageOne.pageNo = val
            this.getList()
        },
        // 分页大小
        handletableDataSize(val) {
            this.pageOne.pageSize = val
            this.getList()
        },
        // 选择列的展示方式
        tableChekboxChange(val) {
            this.tempTableChekbox = val.map((item) => item)
        },
        //重置
        clearData() {
            this.reload()
        },
        //导出excel
        async createExcel() {
            const res = await request2({
                url: "/admin/section/info/export",
                method: "POST",
                data: {},
                responseType: "blob",
            })
            const blob = new Blob([res], { type: "application/vnd.ms-excel" })
            const fileName = "楼栋信息.xls"
            const linkNode = document.createElement("a")

            linkNode.download = fileName //a标签的download属性规定下载文件的名称
            linkNode.style.display = "none"
            linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
            document.body.appendChild(linkNode)
            linkNode.click() //模拟在按钮上的一次鼠标单击

            URL.revokeObjectURL(linkNode.href) // 释放URL 对象
            document.body.removeChild(linkNode)
        },
        // 导入
        async fileChange(event) {
            console.log(event)
            const file = event.target.files[0]
            console.log(file)
            const personType = "1"
            let config = {
                headers: { "Content-Type": "multipart/form-data" },
            }
            let formData = new FormData()
            formData.append("personType", personType)
            console.log(formData)
            formData.append("file", file)
            let result = await this.$http.post(
                "/admin/section/info/importExcel",
                formData,
                config
            )
            // 清空文件
            const fileEle = document.getElementById("speechUpload")
            fileEle.value = ""
            if (result.code == 200) {
                this.$message.success(result.message)
                this.getList()
            } else {
                this.$message.warning(result.message)
            }
        },
        // 获取数据
        getList() {
            let params = {
                pageNo: this.pageOne.pageNo,
                pageSize: this.pageOne.pageSize,
                name: this.name,
                phone: this.phone,
                personIdCard: this.personIdCard,
            }
            this.$http
                .request({
                    url: "/admin/communityWorker/info/findListBySocialOrg",
                    method: "POST",
                    data: params,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.tableData = []
                            this.pageOne.total = 0
                            return
                        }
                        this.tableData = res.content.list
                        this.pageOne.total = res.content.count
                    }
                })
        },
        // 操作方法
        handleTableForm(title, row) {
            this.addressInfo = {
                title: title,
                id: title == "新增" ? "" : row.id,
                state: true,
            }
            this.addressSate = true
        },
    },
}
</script>
<style lang="less" scoped>
/deep/.table_title {
    margin-top: 20px !important;
}

.searchBox {
    display: flex;
    .content {
        flex: 1;
    }
}
/deep/.btn_group {
    margin-top: 0px !important;
}
.button {
    margin-bottom: 4px;
}
.labelImportBtn {
    background: orange;
    border-radius: 3px;
    cursor: pointer;
    margin: 0 10px;
    font-size: 12px;
    padding: 0 17px;
    color: #fff;
    line-height: 28px;
    display: inline-block;
}
.operBtn {
    cursor: pointer;
    margin-left: 10px;
}
</style>